class ProductFeaturesCarousel extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-feature-slide]'));
    this.thumbs = Array.from(this.querySelectorAll('[data-feature-thumb]'));

    this.thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => this.activate(Number(thumb.dataset.featureThumb)));
    });

    if (this.slides.length) this.activate(0);
  }

  activate(index) {
    if (index < 0 || index >= this.slides.length) return;

    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === index);
    });
    this.thumbs.forEach((thumb, i) => {
      thumb.classList.toggle('is-active', i === index);
      thumb.setAttribute('aria-current', i === index ? 'true' : 'false');
    });
  }
}

customElements.define('product-features-carousel', ProductFeaturesCarousel);
